/* @ngInject */
export  default function SpiceApiService($http, __env) {
    'use strict';


    return {
        doesSpiceFileExist:function (uniquePart) {
            return $http.get(
                __env.documentationUrl + 'download/spice/' + uniquePart.uniquePn ).then(({data}) => {
                uniquePart.spice = data!=="";
                uniquePart.spiceUrl = data;
            }).catch(e => {
                console.log(e);
            })
        }
    };
}